export type Doc = {
  id: number
  author: string[]
  post: string[]
  link: string
}

export type Client = {
  id: number
  logo: string
  link: string
}

export const clients: Client[] = [
  {
    id: 1,
    logo: require('./assets/polymedia.png'),
    link: 'https://www.polymedia.ru/'
  },
  {
    id: 2,
    logo: require('./assets/ecco.png'),
    link: 'https://www.ecco.ru/'
  },
  {
    id: 3,
    logo: require('./assets/udora.png'),
    link: 'https://udora.com/ru/'
  }
]
